import { React, useState } from "react";
import { Modal, TextField, Button, Box } from "@mui/material";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";

export const AutorizarModificacionModal = ({
    open,
    onClose,
    ejercicio,
    periodo
}) => {

    const [comentario, setComentario] = useState("");

    const handleActualizar = () => {
        const post = {
            ejercicio: ejercicio,
            periodo: periodo,
            comentario: comentario,
            usuario: 0
        };

        request
            .post("ConciliacionIngresos/ActualizarConciliacion", post)
            .then((res) => {

                Swal.fire(
                    "Éxito",
                    "Se autorizó la modificacion de la conciliación.",
                    "success"
                );
                setComentario("");
                onClose();
            })
            .catch((err) => {

                Swal.fire(
                    "Error",
                    JSON.stringify(err),
                    "error"
                );
            });

        
    };

    return (
        <Modal open={open} onClose={onClose} disableScrollLock >
            <div className="autorizar-modificacion-conciliacion">

                <div className="autorizar-modificacion-conciliacion-plantilla">
                    <div
                        className="plantilla-screen-filtro-container"
                        id="mdlFiltros-modal"
                    >
                        <PlantillaScreen
                            titulo={"AUTORIZAR MODIFICACION"}
                            className_main={1}
                            className={"plantilla-screen-filtro-container-modal"}
                        >

                            <div className="cerrar-modal-button" onClick={onClose}>
                                X
                            </div>

                            <div className="ayuda-grid">

                                <div className="confirm-text">
                                    ¿Estás seguro de que quieres autorizar la modificación de la conciliación?
                                </div>

                                <Box sx={{ padding: "15px" }}>
                                    <TextField
                                        label="Comentario"
                                        value={comentario}
                                        onChange={(e) => setComentario(e.target.value)}
                                        multiline
                                        rows={4}
                                        fullWidth
                                        placeholder="Escribe el motivo de la autorización..."
                                    />
                                </Box>

                                <div className="modal-actions">
                                    <Button
                                        variant="contained"
                                        onClick={() => handleActualizar()}
                                    >
                                        Autorizar
                                    </Button>
                                </div>

                            </div>


                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};